import {memo} from 'react';

import styled from 'styled-components';

import {media} from '~/shared/theme/media';
import {InnerWidthContainer} from '~/shared/components/styled';
import {flexCenterHorizontally} from '~/shared/theme/FlexLayout';
import FooterTopSection from '~/shared/components/PageFooter/10bis/FooterSection/FooterTopSection';
import {useIsAndroid, useIsIOS} from '~/shared/hooks/deviceInfo';

import footerSectionData from './footerSectionData.json';
import FooterSection from './FooterSection';

const Root = styled.footer.attrs({
  className: 'darkCover',
  'data-test-id': 'page-footer',
})<{isBannersShown: boolean}>`
  width: 100%;
  display: flex;
  background-color: ${({theme}) => theme.colors.backgroundDark};
  color: ${({theme}) => theme.colors.surface};
  z-index: 1;
  min-height: ${({theme}) => theme.footer.height}px;
  ${({isBannersShown}) => isBannersShown && 'padding-bottom: 80px;'}
  ${media.minLargeMobile`
    ${({isBannersShown}) => isBannersShown && 'padding-bottom: 68px;'}
  `}
`;

const FooterSectionsWrapper = styled.div`
  padding: 24px 0 40px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  ${media.minLargeMobile`
    flex-direction: row;
    flex-wrap: wrap;
    gap: 40px 33px;
  `}
  ${media.minLargeTablet`
    gap: 40px 80px;
  `}
  ${media.minLargeDesktop`
    gap: 40px 17px;
  `}
`;

const FooterSectionWrapper = styled.section<{minWidth?: number}>`
  display: flex;
  flex: 1;
  ${media.minLargeMobile`
    flex: none;
  `}
`;

const FooterInnerWidthContainer = styled(InnerWidthContainer)`
  ${flexCenterHorizontally}
  flex-direction: column;
  padding: 0 16px;
  ${media.minLargeMobile`
    padding: 0;
  `}
`;

const Footer = ({isBannersShown}: {isBannersShown: boolean}) => {
  const isIOS = useIsIOS();
  const isAndroid = useIsAndroid();

  return (
    <Root isBannersShown={isBannersShown}>
      <FooterInnerWidthContainer>
        <FooterTopSection isIOS={isIOS} isAndroid={isAndroid} />
        <FooterSectionsWrapper>
          {footerSectionData.map(section => (
            <FooterSectionWrapper key={section.title}>
              <FooterSection {...section} />
            </FooterSectionWrapper>
        ))}
        </FooterSectionsWrapper>
      </FooterInnerWidthContainer>
    </Root>
  );
};

export default memo(Footer);
